export enum TextDecorationStyle {
  solid,
  double,
  dotted,
  dashed,
  wavy,
}
